// extracted by mini-css-extract-plugin
export default {"memberRow":"MemberRow-module__memberRow___RrVZh","memberProfilePicture":"MemberRow-module__memberProfilePicture___QrHNZ","memberName":"MemberRow-module__memberName___JRGD2"};